<template>
  <li :data-task-id="task.id" :class="[{'task mb-3': true, 'editing soft-shadow': isEditing, 'd-none': isDeleted}, `variant-${variant}`]">
    <!-- {{ task.id }} -->
    <div class="media">
      <!--
      <div
        v-if="!isEditing"
        class="media-left mr-2">
        <a
          href="#" class="edit text-decoration-none text-muted px-1 py-0"
          @click.prevent="edit">
          <i class="fa fa-pencil"></i>
        </a>
      </div>
      -->
      <div class="media-body align-items-start pr-1">
        <div class="custom-control custom-checkbox">
          <input
            :id="elId"
            type="checkbox"
            class="custom-control-input"
            :disabled="readonly"
            v-model="task.done"
          >
          <label
            :for="elId"
            class="custom-control-label pl-1">
            <div
              v-if="!isEditing"
              @click.prevent="edit"
            >
              <div>
                <span class="task-name">
                  {{ title }}
                </span>
                <span
                  v-if="isOverdue"
                  class="ml-1 text-danger small">
                  <i class="fa fa-flag mr-1"></i>
                  Overdue
                </span>
                <span
                  v-if="!isEditing && editable"
                  class="edit small text-decoration-none text-muted ml-2">
                  <i class="fa fa-pencil mr-1"></i>
                  Edit
                </span>
              </div>
              <div class="d-block small text-muted" v-html="description"></div>
            </div>
          </label>
          <div
            class="editor"
            v-if="isEditing"
          >
            <trix
              class="trix-mini mb-2"
              placeholder="What do you need to get done?"
              v-model="editing.title" />
            <trix
              class="trix-mini mb-2 small"
              placeholder="Notes"
              v-model="editing.description" />
            <multiselect
              v-model="editing.meta.lead_source"
              :options="leadSources"
              :multiple="true"
            ></multiselect>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isEditing">
      <hr>
      <div class="settings d-flex align-items-start">
        <a
          v-if="!dueAt"
          href="#"
          class="btn btn-sm btn-link text-decoration-none text-body pl-0"
          @click.prevent="addDueDate()"
        >
          <i class="fa fa-calendar mr-1"></i>
          Set due date...
        </a>
        <div :class="[
          'd-flex',
          {
            'mb-3': variant === 'narrow'
          }
        ]">
          <b-form-datepicker
            v-if="dueAt"
            v-model="dueAt"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="en"
            size="sm"
            class="mr-1"
          ></b-form-datepicker>
          <b-select
            v-if="dueAt"
            v-model="task.frequency"
            size="sm"
            class="col-5 mr-1"
            :options="frequencies"
          >
            <template #first>
              <b-form-select-option
                :value="null"
              >
                Does not repeat
              </b-form-select-option>
            </template>
          </b-select>
        </div>
        <div class="d-flex ml-auto">
          <div class="btn-group">
            <button
              class="btn btn-primary btn-sm"
              type="button"
              @click.prevent="save()"
            >
              Save
            </button>
            <button type="button" class="btn btn-sm btn-primary dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="sr-only">Toggle Dropdown</span>
            </button>
            <div class="dropdown-menu">
              <a
                class="dropdown-item"
                href="#"
                @click.prevent="save()"
              >
                Save
              </a>
              <a
                v-if="dueAt"
                href="#"
                class="dropdown-item"
                @click.prevent="removeDueAt()"
              >
                Remove Due Date
              </a>
              <a
                class="dropdown-item"
                href="#"
                @click.prevent="trash()"
              >
                Delete
              </a>
              <div class="dropdown-divider"></div>
              <a
                class="dropdown-item"
                href="#"
                @click.prevent="cancel()"
              >
                Cancel
              </a>
            </div>
          </div>
          <!--
          <a
            href="#"
            class="btn btn-sm btn-link text-decoration-none text-body ml-2"
            @click.prevent="cancel">
            Cancel
          </a>
          <a
            href="#"
            :class="['btn btn-sm btn-link text-decoration-none text-body px-1 ml-2', {'ml-auto': variant === 'narrow' }]"
            @click.prevent="trash">
            <i class="fa fa-trash"></i>
          </a>
          <a
            href="#"
            class="btn btn-outline-dark btn-sm"
            @click.prevent="save">
            Save
          </a>
          -->
        </div>
      </div>
    </div>
  </li>
</template>

<style lang="scss" scoped>
.task {
  position: relative;
  &.editing {
    margin: 0.25rem 0rem -1.2rem -1.6rem;
    padding: 1rem 1.5rem 1rem 1.6rem;
    background-color: #fff;
    border-radius: 4px;
    @media screen and (max-width: 991px) {
      margin: 0.25rem -1.6rem -1.2rem -1.6rem;
    }
    &.variant-narrow {
      margin: 0.25rem -1.6rem -1.2rem -1.6rem;
    }
  }
  .edit {
    display: none;
  }
  .editor {
    margin-top: -20px;
  }
  &:hover {
    .edit {
      color: #111 !important;
      display: inline-block;
    }
  }
}

.input-group {
  .form-control {
    border-left: 0;
  }
}
</style>

<script>
import { get, merge, map } from 'lodash'
import moment from 'moment'
import { v1 as uuidv1 } from 'uuid'
import Trix from '@/components/Trix'
import $ from 'jquery'
import alertify from 'alertify.js'
import { saveTask, deleteTask, markTaskComplete, markTaskIncomplete } from '@/api'
// import Pickadate from '@/components/Pickadate'
import { mapMutations } from 'vuex'
import Multiselect from 'vue-multiselect'
import WithoutWatchers from '@/mixins/WithoutWatchers'

export default {
  components: {
    Multiselect,
    // Pickadate,
    Trix
  },
  mixins: [WithoutWatchers],
  props: {
    variant: {
      type: String,
      default: 'default'
    },
    value: {
      type: Object,
      default () {
        return {
          id: null,
          title: null,
          description: null,
          due_at: null,
          repeat: null,
          frequency: null,
          _editing: false,
          _deleted: false
        }
      }
    },
    editable: {
      type: Boolean,
      default: true,
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      elId: uuidv1(),
      task: this.value,
      editing: Object.assign({}, this.value),
      setDueAt: !!this.value.due_at,
      scrollToTaskTimeout: null
    }
  },
  computed: {
    leadSources () {
      return window._leadSources || []
    },
    frequencies () {
      return window._frequencies || []
    },
    isOverdue () {
      return !this.task.done && moment(this.task.due_at).utc().isBefore(moment(), 'day')
    },
    isDeleted () {
      return this.task._deleted
    },
    isEditing () {
      return this.task && this.task._editing
    },
    title: {
      get () {
        return $('<span></span>').html(get(this.task, 'title')).text() || 'Untitled task'
      }
    },
    description: {
      get () {
        return get(this.task, 'description')
      }
    },
    dueAt: {
      get () {
        return this.editing.due_at
      },
      set (newValue) {
        if (newValue) {
          let m = moment(newValue)
          this.editing.due_at = m.isValid() ? m.format('YYYY-MM-DD') : null
        }
      }
    }
  },
  watch: {
    value () {
      this.task = this.value
    },
    isEditing () {
      if (this.isEditing) {
        this.incrementEditingCount()
        this.scrollToThisTask()
      } else {
        this.decrementEditingCount()
      }
    },
    async 'task.done' () {
      let response = null
      if (this.task.done) {
        try {
          response = await markTaskComplete(this.task)
          this.$emit('completed')
        } catch (e) {
          this.$withoutWatchers(() => {
            this.task.done = false
            alertify.alert('Oops! Failed to save. Please try again.')
          })
        }
      } else {
        try {
          response = await markTaskIncomplete(this.task)
          this.$emit('incompleted')
        } catch (e) {
          this.$withoutWatchers(() => {
            this.task.done = true
            alertify.alert('Oops! Failed to save. Please try again.')
          })
        }
      }
      if (response) {
        this.$emit('toggled', this.task.done)
      }
    }
  },
  methods: {
    ...mapMutations('tasks', [
      'incrementEditingCount',
      'decrementEditingCount'
    ]),
    scrollToThisTask (delay) {
      clearTimeout(this.scrollToTaskTimeout)
      this.scrollToTaskTimeout = setTimeout(() => {
        $('html, body').animate({
          scrollTop: $(`[data-task-id="${this.task.id}"]`).offset().top - 30
        })
      }, delay)
    },
    edit () {
      if (this.editable) {
        this.task._editing = true
      }
    },
    addDueDate () {
      this.dueAt = moment().format('YYYY-MM-DD')
    },
    removeDueAt () {
      this.editing.due_at = null
      this.scrollToThisTask()
    },
    save () {
      this.task.title = this.editing.title
      this.task.description = this.editing.description
      this.task.due_at = this.editing.due_at
      this.task.meta.lead_source = this.editing.meta.lead_source
      saveTask(this.task)
      this.task._editing = false
      this.scrollToThisTask()
    },
    cancel () {
      this.task._editing = false
    },
    trash () {
      alertify.confirm('Are you sure you want to delete this task?', () => {
        deleteTask(this.task)
        this.task._editing = false
        this.task._deleted = true
      })
    }
  }
}
</script>
